import React, { useMemo, useEffect, useState } from 'react';
import '@react-pdf-viewer/core/lib/styles/index.css';
import PdfViewer from '../components/PdfViewer';

import {
  Button,
  Typography,

} from '@qtm/react2';
import { useTheme } from '../ThemeContext';
import useMediaQuery from '../hooks/useMediaQuery';
import BackButton from '../components/BackButton';



export default function CoreServicesPage(showBackButton) {
  const { darkMode } = useTheme();
  const isTablet = useMediaQuery('(max-width: 1023px)');
  const isMobile = useMediaQuery('(max-width: 640px)');
  const [pdfFile, setPdfFile] = useState(() => {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem('selectedServicePdf') || null;
  });
  const pdfViewerRef = React.useRef(null);

  const [selectedService, setSelectedService] = useState(() => {
    if (typeof window === 'undefined') return null;
    // Initialize selected service with local storage value if it existss
    const storedService = localStorage.getItem('selectedService');
    return storedService && storedService !== 'null' ? storedService : null;
  });

  const [activeTab, setActiveTab] = useState(() => {
    if (typeof window === 'undefined') return 'Compute';
    // Default tab is compute
    return localStorage.getItem('activeTab') || 'Compute';
  });

  const handleMouseEnter = (e) => {
    e.target.style.backgroundColor = clickableItemHoverStyle.backgroundColor;
  };

  const handleMouseLeave = (e) => {
    e.target.style.backgroundColor = '';
  };

  //
  const handleServiceClick = (pdfFileName, serviceName) => {
    const nextService = serviceName || null;
    setSelectedService(nextService);

    if (typeof window !== 'undefined') {
      if (nextService) {
        localStorage.setItem('selectedService', nextService);
      } else {
        localStorage.removeItem('selectedService');
      }
    }

    if (pdfFileName) {
      setPdfFile(pdfFileName);
      if (typeof window !== 'undefined') {
        localStorage.setItem('selectedServicePdf', pdfFileName);
      }
    } else {
      setPdfFile(null);
      if (typeof window !== 'undefined') {
        localStorage.removeItem('selectedServicePdf');
      }
    }
  };
  
  useEffect(() => {
    if (!pdfViewerRef.current) return;
    if (pdfFile) {
      pdfViewerRef.current.openPdfModal(pdfFile);
    } else {
      pdfViewerRef.current.closePdfModal();
    }
  }, [pdfFile]);

  // Display subscribe button if required for a specific service
  // Display the doc button if required for a specific service
  const subscribeAndDocItem = (name, subLink, docLink) => {
    let htmlItem = '';
    if (name) {
      htmlItem = "to " + name;
    }
    else { htmlItem=null}
    return (
      <>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          {docLink && <Button
            style={subscribeButton}
            onClickEvent={() => window.location.href = docLink}>Documentation</Button>}
          {subLink && <Button
            style={subscribeButton}
            onClickEvent={() => window.open(
              subLink,
              '_blank'
            )}> Subscribe {htmlItem}</Button>}

        </div>
      </>
    )
  };

  const containerStyle = useMemo(
    () => ({
      maxWidth: 1100,
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      gap: isMobile ? 32 : 48,
    }),
    [isMobile],
  );
  const heroStyles = useMemo(
    () => ({
      wrapper: {
        borderRadius: 36,
        padding: isMobile ? '32px 24px 40px' : isTablet ? '40px 32px 48px' : '48px 56px 56px',
        background: darkMode
          ? 'linear-gradient(135deg, #1f2937 0%, #111827 35%, #1f2937 100%)'
          : 'linear-gradient(135deg, #729bcd 0%, #25286b 35%, #729bcd 100%)',
        color: '#fff',
        boxShadow: '0 24px 60px rgba(69, 38, 144, 0.3)',
        display: 'flex',
        flexDirection: 'column',
        gap: isMobile ? 24 : 32,
        alignItems: isTablet ? 'flex-start' : 'center',
        textAlign: isTablet ? 'left' : 'center',
      },
      heading: {
        fontSize: isMobile ? '34px' : isTablet ? '46px' : '52px',
        fontWeight: 700,
        letterSpacing: '-0.02em',
        margin: 0,
      },
      subtitle: {
        fontSize: isMobile ? '16px' : '18px',
        margin: 0,
        maxWidth: isTablet ? '100%' : '720px',
        opacity: 0.92,
      },
      linksRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 16,
        justifyContent: isTablet ? 'flex-start' : 'center',
      },
      linkButton: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 18px',
        borderRadius: 999,
        color: '#fff',
        background: 'rgba(255,255,255,0.14)',
        border: '1px solid rgba(255,255,255,0.25)',
        fontWeight: 600,
        textDecoration: 'none',
      },
      image: {
        width: '100%',
        borderRadius: 24,
        boxShadow: darkMode
          ? '0 24px 40px rgba(15, 23, 42, 0.45)'
          : '0 24px 40px rgba(15, 23, 42, 0.25)',
      },
    }),
    [darkMode, isMobile, isTablet],
  );

  const contentCardStyle = useMemo(
    () => ({
      backgroundColor: darkMode ? '#111827' : '#ffffff',
      borderRadius: 24,
      padding: isMobile ? 24 : 32,
      boxShadow: darkMode
        ? '0 16px 32px rgba(15, 23, 42, 0.5)'
        : '0 16px 32px rgba(15, 23, 42, 0.08)',
      display: 'flex',
      flexDirection: 'column',
      gap: isMobile ? 20 : 24,
    }),
    [darkMode, isMobile],
  );

  const serviceListStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };

const Tabstyle = useMemo(
  () => ({
    margin: 0,
    paddingLeft: isMobile ? '1.2rem' : '1.6rem',
    overflowX: isMobile ? 'auto' : 'visible',
  }),
  [isMobile],
  );

  const psListStyle = useMemo(
    () => ({
      margin: '8px 0 0',
      paddingLeft: isMobile ? '1.2rem' : '1.6rem',
      display: 'flex',
      type: 'circle',
      flexDirection: 'column',
      gap: 6,
    }),
    [isMobile],
  );


  const pageStyle = useMemo(
    () => ({
      minHeight: '100vh',
      backgroundColor: darkMode ? '#0f172a' : '#f7f8fb',
      padding: isMobile ? '32px 16px 56px' : isTablet ? '48px 24px 72px' : '1px 2px 6px',
      color: darkMode ? '#e2e8f0' : '#0f172a',
    }),
    [darkMode, isMobile, isTablet],
  );

  const coreServicesItem = [
    'Compute',
    'Network',
    'Identity',
    'Security & Compliance',
    'Data & AI',
    'Data Centric Security',
    'Insights & Analytics',
  ];

  const clickableItemStyle = useMemo(
    () => ({
      display: 'inline-flex',
      cursor: 'pointer',
      justifyContent: 'center',
      fontWeight: 600,
      padding: '10px 20px',
      margin: '5px',
      border: '1px solid #041295',
      borderRadius: 999,
      boxShadow: darkMode ? '0 2px 5px rgba(0,0,0,0.3)' : '0 2px 5px rgba(0,0,0,0.1)',
      background: 'rgba(255,255,255,0.14)',
      color: darkMode ? '#fff' : '#041295',
      transition: 'background-color 0.2s, box-shadow 0.2s',
    }),
    [darkMode]
  );



  const subscribeButton = useMemo(
    () => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: isMobile ? '0 10px' : '0',
      padding: isMobile ? '8px 16px' : '10px 20px',
      color: '#FFF',
      borderRadius: '5px',
      textDecoration: 'none',
    }),
    [isMobile]
  );

  const clickableItemHoverStyle = useMemo(
    () => ({
      backgroundColor: darkMode ? '#1f2937' : '#e5e7eb',
      boxShadow: darkMode ? '0 2px 10px rgba(0,0,0,0.5)' : '0 2px 10px rgba(0,0,0,0.15)',
    }),
    [darkMode]
  );


  const heroLinks = [
    {
      label: 'Pricelist',
      href: 'https://thalesgroup.sharepoint.com/sites/TrustNest-Portal/SitePages/Pricing.aspx',
      external: true,
    },
    {
      label: 'Contact Digital Partners',
      href: 'https://thalesgroup.sharepoint.com/sites/TrustNest-Portal/SitePages/Digital%20Partners.aspx',
      external: true,
    },
    {
      label: 'Subscribe',
      href: 'https://postit.service-now.com/esc?id=tdf_ec_home',
      external: true,
    },
  ];


  const serviceDesc = {
    ManagedKubernetes: (
      <>
        <Typography component='title-3'>Managed Kubernetes</Typography>
        <br></br>
        <p>A TrustNest managed service is a technical stack provisioned to users. In opposition to landing zone, a managed service is a ready-to-use service. Meaning: Kubernetes is installed with transversal services which provide:</p>
        <ul style={psListStyle} >
          <li>Observability</li>
          <li>Security</li>
          <li>Access Management</li>
          <li>Performance</li>
          <li>Storage</li>
          <li>Cost Optimization</li>
        </ul>
        <p>For each feature, a dedicated documentation page has been created to provide few details, the use cases, how to enable or disable it, and finally some tips & troubleshooting. To discover in detail all the features, look at <a href="https://trustnest-docs.thalesdigital.io/docs/K8SaaS/" >K8SAAS User Guide</a>.</p>
        <br></br>
        {subscribeAndDocItem('', 'https://postit.service-now.com/esc?id=sc_cat_item&sys_id=90158756dba6695055a55947f4961909', 'https://trustnest-docs.thalesdigital.io/docs/K8SaaS/')}
      </>
    ),
    LZ: (
      <>
        <Typography component='title-3'>Infrastructure Landing Zone</Typography>
        <br></br>
        <p>An infrastructure Landing Zone is a preconfigured cloud environment that accounts for scale, security, governance, networking, and identity. In terms of operating model, you’re the owner of the environment. It means you will be accountable for the security and the availability.</p>
        <p>You can choose to use an Azure Landing Zone for the following use cases:</p>
        <ul style={psListStyle}>
          <li>Deploy a solution that needs Virtual Machines</li>
          <li>Deploy an IaaS Infrastructure in a secured environment and benefit from services like Monitoring, Patch Management, Antivirus, Vulnerability Management, …</li>
          <li>Migration of a Datacenter while keeping Network Connectivity with others Datacenters</li>
          <li>Deploy an AI solution with Azure PaaS services like Databricks, Datalake Storage, …</li>
          <li>Deploy Serverless architecture using services like Azure Functions</li>
          <li>Deploy Event Driven or IoT solutions (using Azure services like Event Hub, IoT Hub, …)</li>
        </ul>
        <br></br>
        <p>In some cases, it’s better to use other types of Trustnest Cloud Services:</p>
        <ul style={psListStyle}>
          <li>Host a container based application : Use instead our Managed Kubernetes Services k8saas</li>
          <li>Host your own Software Factory : Use instead our Software Factory based on popular tools like Gitlab and Artifactory</li>
          <li>Host your own Datalake : Use instead our Datalake</li>
          <li>Use only Azure Database Managed Services : Use instead our Managed Databases services</li>
        </ul>
        <p>For each feature, a dedicated documentation page has been created to provide few details, the use cases, how to enable or disable it, and finally some tips & troubleshooting. To discover in detail all the features, look at <a href="https://trustnest-docs.thalesdigital.io/docs/IaaS-LZ/" >Infrastructure Landing Zone documentation</a>.</p>
        <br></br>
        {subscribeAndDocItem('', 'https://postit.service-now.com/esc?id=sc_cat_item&sys_id=90158756dba6695055a55947f4961909', 'https://trustnest-docs.thalesdigital.io/docs/IaaS-LZ/')}
      </>
    ),
    'FinOpsGreenOps': (
      <>
        <Typography component='title-3'>TDP assets dahsboard</Typography>
        <Typography component='body-1'>It is automatically available when you have a role on a TDF account. No need to subscribe to it. You can access the dashboard {''}<a
          href='https://app.powerbi.com/groups/me/apps/bd781e6a-6078-4206-8d23-725b7feaccbb/reports/0d6888ea-c618-4f23-9375-0a4eb1894a98/684cae7415ef6fd3245b?ctid=737c6905-f186-4bcf-afb3-43e349ee23a3&experience=power-bi'
          target={'_blank'}
          rel={'noopener noreferrer'}>here
        </a>.
        </Typography>

        <img src="images/asset-dashboard.png" alt="TrustNest tdp asset dash" style={heroStyles.image} />
        <br></br>
        <Typography component='title-3'>FinOps & GreenOps dahsboard</Typography>
        <Typography component='body-1'>Visualise and optimise your Azure Cloud consumptions on the TrustNest Digital Platform.</Typography>
        <Typography>Measure, monitor, and manage your usage to reduce both financial and environmental impacts.
          You can access the dashboard {''}<a
            href='https://app.powerbi.com/groups/me/apps/bd781e6a-6078-4206-8d23-725b7feaccbb/reports/5822e88b-47a7-47bb-b580-175d486cb294/a774243ddfb7375472ce?ctid=737c6905-f186-4bcf-afb3-43e349ee23a3&experience=power-bi'
            target={'_blank'}
            rel={'noopener noreferrer'}>here
          </a>.
        </Typography>

        <img src="images/finops-dash.png" alt="TrustNest finops dash" style={heroStyles.image} />
        <br></br>
        <img src="images/greenops-dash.png" alt="TrustNest greenops dash" style={heroStyles.image} />

        <br></br>
        {subscribeAndDocItem('FinOps dashboard', 'https://postit.service-now.com/esc?id=sc_cat_item&sys_id=cd7ba07edb53f15055a55947f49619eb', '')}


      </>
    ),
    'CyberDash': (
      <>
        <Typography component='title-3'>Cyber dashboard</Typography>
        <br></br>
        <Typography component='body-1'>Cyber dashboarding is provided for any user referenced as security contact of a given TDF account for the subscription of Cloud services (Landing Zone, Managed Kubernetes...). Access the dashboard {''}<a href="https://app.powerbi.com/groups/me/apps/97c71a0d-dc65-419f-8756-50995933c76f/reports/a1628b5c-eb0d-4d41-9cf9-d29e0d11fdf0/ReportSection65942579115aec2e8c01?redirectedFromSignup=1&experience=power-bi"
          target={'_blank'}
          rel={'noopener noreferrer'}>here</a>.
        </Typography>
        <br></br>
        <img src="images/kpi-dashboard-cyber-1.png" alt="TrustNest cyber dash1" style={heroStyles.image} />
        <br></br>
        <img src="images/kpi-cyber-dashboard-2.png" alt="TrustNest cyber dash2" style={heroStyles.image} />

      </>
    ),
    'CorporateAddon': (
      <>
        <Typography component='title-3'>Corporate addon</Typography>
        <br></br>
        <Typography component='subtitle-1'>What is the corporate add-on objective? </Typography>
        <Typography component='body-1'>The objective of the corporate addon is to guarantee that the workstations which access corporate environments are sufficiently mastered by the Thales Group. It reduces the risk of data leakage.</Typography>
        <br></br>
        <Typography component='subtitle-1'>How the corporate add-on works?</Typography>
        <Typography component='body-1'>2 methods depending on the technical constraints: </Typography>

        <Typography component='subtitle-2'>Method 1: Network Isolation</Typography>
        <ul>
          <li>The corporate addon enforces network and naming resolution to:
            <ul>
              <li>forbid any internet exposition of IaaS and PaaS services</li>
              <li>use Thales internal naming resolution (domain confidential) and private IP plan (IP plan confidential)</li>
              <li>accept connections only from RIE networks and TNAP laptops configured with custom VPN rules</li>
            </ul>
          </li>
        </ul>
        <Typography component='subtitle-2'>Method 2: Three authentication factor (ID/password + Microsoft Authenticator + Endpoint compliance)</Typography>
        <Typography component='body-1'>In some cases, the network isolation is not possible (Total cost of Ownership or not feasible technically). The corporate addon is a hardened policy checking the compliance of your device in addition to the standard authentication methods. In particular: the device should use Network as outbound traffic OR the device should be a TNAP with a compliant security status. </Typography>
        <br></br>
        <Typography component='subtitle-1'>What does it allow?</Typography>
        <ul>
          <li>Developing in a safe network bubble</li>
          <li>Provide large access from RIE networks</li>
          <li>Use TNAP to develop</li>
        </ul>
        <br></br>
        <Typography component='subtitle-1'>What does it not allow?</Typography>
        <ul>
          <li>Provide access to partner or contractor (with a Thales identity) -> NOT ALLOWED</li>
          <li>Provide an on-prem interconnection with corporate environments –> NOT ALLOWED</li>
          <li>Use TNAP to develop</li>
        </ul>
        <br></br>
        <Typography component='subtitle-1'>Where is it deployable?</Typography>
        <Typography component='body-1'>Corporate addon can be enabled on both landing zone and all managed services.</Typography>
        <br></br>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>        
        <Typography component='subtitle-2'>Infrastructure Landing with corporate addon</Typography>
        {subscribeAndDocItem('', 'https://postit.service-now.com/esc?id=sc_cat_item&sys_id=90158756dba6695055a55947f4961909', 'https://trustnest-docs.thalesdigital.io/docs/IaaS-LZ/corporate-addon/')}
        <br></br>
        <Typography component='subtitle-2'>Managed Kubernetes with corporate addon</Typography>
        {subscribeAndDocItem('', 'https://postit.service-now.com/esc?id=sc_cat_item&sys_id=90158756dba6695055a55947f4961909', 'https://trustnest-docs.thalesdigital.io/docs/K8SaaS/Features/corporate-addon/')}
        </div>
      </>
    ),
    BMN: (

      <>
        <Typography component='title-3'>Business Managed Network security services</Typography>
        <br></br>

        <Typography component='body-1'>Discover our {''}<a href="https://trustnest-docs.thalesdigital.io/docs/BMN/" >BMN security services</a></Typography>
        <br></br>
        {subscribeAndDocItem('BMN services', 'https://postit.service-now.com/esc?id=emp_taxonomy_topic&topic_id=c6a6c02c47f55610b694ba5e036d4378', 'https://trustnest-docs.thalesdigital.io/docs/BMN/')}
      </>
    ),
    IntAccess: (
      <>
      <Typography component='title-3'>Internet Access</Typography>
      <br></br>
      <Typography component='body-1'>In Azure, VMs created within a virtual network without explicitly defined outbound connectivity are currently assigned a default implicit IP. This IP allows these VMs to communicate with the internet for outbound access without any additional configuration.</Typography>
      <br></br>
      <Typography component='body-1'>Microsoft is strengthening Azure’s security posture by retiring the default outbound access for all newly deployed Azure Virtual Machines (VMs) starting September 30th, 2025.</Typography>
      <br></br>
      <Typography component='body-1'>To allow VMs to continue benefiting from internet access, TDP propose a solution to manage your Internet outbound access through a, Azure Firewall, managed services by TDP.</Typography>

      {subscribeAndDocItem('Internet Access', 'https://trustnest-docs.thalesdigital.io/docs/Network/Postit/TDP-Secure-Internet-Outbound-postit/#how-to-request-tdp-secure-newgen-internet-outbound-access', 'https://trustnest-docs.thalesdigital.io/docs/Network/Postit/TDP-Secure-Internet-Outbound-postit/')}
      </>
    ),
    managedDatabase: (
      <>
        <Typography component='title-3'>Managed Database</Typography>
        <br></br>
        <Typography component='body-1'>Most stateful applications need to persist and access efficiently to data. Databases are often used to provide these capabilities to facilitate the development, but led to some challenges too.</Typography>
        <Typography component='subtitle-2'>Challenges</Typography>
        <ul>
          <li>How to choose the right database?</li>
          <li>How to size the database to decrease the costs and to optimize the performances?</li>
          <li>How to manage the security and the availability while reducing the impact on your system?</li>
        </ul>
        <Typography component='body-1'>DBaas has been launched to answer these challenges. The goal is to simplify the system development while optimizing your run costs.</Typography>
        <br></br>
        <Typography component='subtitle-2'>Service Offers</Typography>
        <Typography component='body-1'>DBaas provides 3 types of databases:</Typography>
        <ul>
          <li>A relational database based on Postgresql Flexible Server</li>
          <li>A non relational database based on CosmoDB</li>
          <li>An indexing database based on Opensearch.</li>
        </ul>
        <br></br>
        <Typography component='body-1'> Follow our {''}
          <a href="https://doc.dbaas.thalesdigital.io/docs/GettingStarted/ChooseTheRightDatabase">guide</a> to choose the right database for your application!</Typography>


        {subscribeAndDocItem('', 'https://postit.service-now.com/esc?id=emp_taxonomy_topic&topic_id=fdb9e67397a50510e239be7fe153af30', 'https://trustnest-docs.thalesdigital.io/docs/DBaaS/')}

      </>
    ),
    B2B: (
      <>
        <Typography component='title-3'>Business to Business user onboarding</Typography>
        <br></br>
        <Typography component='body-1'>A Connected organization is a partner of Thales Digital Factory that is authorized to have Guest accounts in the Thales Digital Platform (aka TDP) Microsoft Entra ID tenant.​</Typography>
        <br></br>
        {subscribeAndDocItem('','https://postit.service-now.com/esc?id=sc_cat_item&sys_id=69f1e64d977ef950b1c6359fe153af50','https://trustnest-docs.thalesdigital.io/docs/IAM-Auth/B2B-external-users-management/connected-orgs-onboarding/')}
        
      </>
    ),
    ConfidentialAddon:(
      <>
        <Typography component='title-3'>Confidential addon</Typography>
        <br></br>
        <Typography component='body-1'>Trustnest infrastructure landing zones provide a way to use Thales CipherTrust provided by Thales CPO to manage your encryption keys.​</Typography>
        <br></br>
        {subscribeAndDocItem('','https://postit.service-now.com/esc?id=sc_cat_item&sys_id=a2be9a5687a6c510a75ceced8bbb3555','https://trustnest-docs.thalesdigital.io/docs/IaaS-LZ/confidential-addon/?h=ciphertrust#ciphertrust-portals-url')}
        
      </>
    ),
    Users: (
      <>
        <Typography component='body-1'>If you are a user of a landing zone or a managed services you may need to:</Typography>
        <li>authenticate the consumer of your application</li>
        <li>authenticate the developers on your environment</li>
        <li>use a technical account to build and deployed your application in your environment</li>
        <br></br>

        {subscribeAndDocItem('','','https://trustnest-docs.thalesdigital.io/docs/IAM/')}

      </>
    ),
    SOC: (
      <>

        {subscribeAndDocItem('','','')}

      
      </>
    )
  }

  // Generate the list of services for a given tab
  const generateTabItems = (items) => {
    return items.map(({  label, pdf, service, key }) => (
      
      <ul key={key || label} style={serviceListStyle}>
        <li

          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={clickableItemStyle}
          onClick={() => handleServiceClick(pdf, service)}
        >
          {label}
        </li>
      </ul>
   
    ));
  };


  const tabContents = {

    Compute: (
      <>
        {generateTabItems([
          { key: 'LZ', label: 'Infrastructure Landing Zone', pdf: '', service: 'LZ' },
          { key: 'ManagedKubernetes', label: 'Managed Kubernetes', pdf: 'https://thalesdigital.sharepoint.com/:b:/r/sites/TrustnestCenter/Shared%20Documents/K8SAAS/K8SAAS-ServiceOffer_20231128_lja_v2.pdf?csf=1&web=1&e=RxnWGN', service: 'ManagedKubernetes' },
        ])}
      </>
    ),
    Network: (
      <>
        {generateTabItems([
          {  label: 'Business Managed Network interco (BMN)', pdf: '', service: 'BMN' },
          {  label: 'Datacenter interco', pdf: '', service: '' },
          {  label: 'Internet access', pdf: '', service: 'IntAccess' },
        ])}
        </>
    ),
    Identity: (
      <>
        
        <Typography component='title-3'>TrustNest Identity and access Management (IAM)</Typography>
        <br></br>
        <Typography component='body-1'>Cloud platforms like TrustNest are more exposed to internet than on-premises environments. Zero Trust architecture is often used to mitigate this by-design vulnerability. Identity and Access Management is a pillar in this architecture; making sure users and applications are well authenticated at any time.</Typography>
        <br></br>
        <ul>
          <li>Use Case A: Management of Thales employees and contractors developing directly on TrustNest (deployment of cloud resources as developer and devops)</li>
          <li>Use Case B: Management of Thales employees and contractors accessing to Function SaaS Services (Software Factory, PostIT, O365 thalesdigital.io tenant)</li>
          <li>Use Case C: Management of Thales employees, contractors and partners accesses to SaaS services (product developed on TrustNest)</li>
          <li>Use Case D: Management of any external accesses to SaaS services (product developed on TrustNest)</li>
        </ul>
        <br></br>
          {generateTabItems([
            {  label: 'User/Service Account/Advanced Service Principal', pdf: '', service: 'Users' },
            {  label: 'B2B User onboarding', pdf: '', service: 'B2B' },
          ])}
        <br></br>

      </>

    ),
    'Security & Compliance': (
      <>
        {generateTabItems([
          {  label: 'SOC 24/7', pdf: 'https://thalesdigital.sharepoint.com/:b:/r/sites/TrustnestCenter/Shared%20Documents/Cyber/C2-TDF-CYB-TDP%20SOC%202023%20presentation.pdf?csf=1&web=1&e=IJeCb0', service: 'SOC' },
          {  label: 'Corporate addon', pdf: '', service: 'CorporateAddon' },
        ])}
      </>
    ),
    'Data & AI': (
      <>
        {generateTabItems([
          {  label: 'Managed Database', pdf: 'https://thalesdigital.sharepoint.com/:b:/r/sites/TrustnestCenter/Shared%20Documents/DBAAS/DBAAS-cycle12_end_lja_20220926_public.pdf?csf=1&web=1&e=cpirVP', service: 'managedDatabase' },
          {  label: 'Data Hub', pdf: '', service: '' },
        ])}
      </>
    ),
    'Data Centric Security': (
      <>
        {generateTabItems([
            {  label: 'Confidential addon', pdf: '', service: 'ConfidentialAddon' },
          ])}
      </>
    ),
    'Insights & Analytics': (
      <>
        {generateTabItems([
          {  label: 'TDP assets, FinOps & GreenOps dashboards', pdf: '', service: 'FinOpsGreenOps' },
          {  label: 'Cyber dashboarding', pdf: '', service: 'CyberDash' },
        ])}
        </>
    )
  };

// Update selected tab
// Unset selected services
// Unset pdf file
  const updateActiveTab = (tab) => {
    setActiveTab(tab);
    if (typeof window !== 'undefined') {
      localStorage.setItem('activeTab', tab);
      localStorage.removeItem('selectedService');
      localStorage.removeItem('selectedServicePdf');
    }
    setPdfFile(null);  // Clear the PDF file when switching tabs
    setSelectedService(null);

  };


  return (
    <div style={pageStyle}>
      <div>
        {showBackButton && <BackButton />}
      </div>


      <div style={containerStyle}>
        <section style={heroStyles.wrapper}>
          <div>
            <h1 style={heroStyles.heading}>TrustNest Core Services</h1>
            <p style={heroStyles.subtitle}>

            </p>

          </div>

          <img src="images/trustnest.png" alt="TrustNest platforms" style={heroStyles.image} />
          <div style={heroStyles.linksRow}>
            {heroLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target={link.external ? '_blank' : '_self'}
                rel={link.external ? 'noopener noreferrer' : undefined}
                style={heroStyles.linkButton}
              >
                {link.label}
              </a>
            ))}
          </div>
        </section>


        <section style={contentCardStyle}>
          <div style={{ position: 'relative' }}>


<ol style={Tabstyle}>
  <ul className="qtm-tabs" style={{ display: 'flex', flexDirection: 'row', gap: '1rem', padding: 0, margin: 0, whiteSpace: 'nowrap' }}>
    {coreServicesItem.map((item) => (
      <li onClick={() => updateActiveTab(item)} tabIndex={0}
        className={`qtm-tab${activeTab === item ? ' qtm-active' : ''}`} style={{ display: 'inline-block' }} >
        <span>{item}</span>
      </li>
    ))}
  </ul>
</ol>
            {/* Displays content of a selected tab */}
            <div id="qtm-tab-content">
              {tabContents[activeTab]}
            </div>
            
          </div>
          {/* Displays description of a specific service when selected in a specific tab */}
          {selectedService && (
            <div>
              {serviceDesc[selectedService]}
            </div>
          )}
          
          {/* Displays when set the pdf for the selected services*/}
          <PdfViewer ref={pdfViewerRef} />
        </section>
      </div >

    </div >


  );
}
